import { Svg } from '../../../genericComponents';
import styled from 'styled-components';

const BaseSvg = styled(Svg)` 
  width: 20px; 
  height: 20px;
  margin: 0 3px;
`
export default function Checkmark({ }) {
  return (<BaseSvg viewbox="0 0 20 20" >
    <path d="M0 0L24 0L24 24L0 24L0 0Z" fill="#3787F5" fillOpacity="0" style={{ mixBlendMode: "multiply" }} fillRule="evenodd" />
    <path d="M0 3.7134L4.50731 8.22071L12.728 -3.96104e-14" transform="translate(6 7.867118)" fill="none" fillRule="evenodd" stroke="#111741" strokeWidth="1.5" strokeLinecap="square" />
  </BaseSvg>)
}

